<template>
  <!-- prettier-ignore -->
  <div/>
</template>

<script setup>
import { getCurrentInstance } from 'vue'

import { useI18n } from 'vue-i18n'
import useLogger from '@/hooks/useLogger'
import useToast from '@/hooks/useToast'

import { NOTIFICATION } from '@/config/constants'

const app = getCurrentInstance()
const { tm } = useI18n()
const { logError } = useLogger()
const { addToast } = useToast()

window.onerror = function (message, _source, _lineno, _colno, error) {
  console.log(message, _source, _lineno, _colno, error)

  if (error) {
    logError(['GLOBAL ERROR -> ', error.stack])
  } else {
    logError(['GLOBAL MESSAGE ->', message])
  }
}

app.appContext.config.errorHandler = err => {
  handleError(err)
}

function handleError(e) {
  logError(['VUE ERROR -> ', e])
  addToast({
    text: tm('error.GENERAL'),
    type: NOTIFICATION.ERROR,
  })

  // report error to Instana
  if (window.ineum) {
    window.ineum('reportError', e)
  }
}
</script>
